"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_WIDTH_TIMEPICKER_CONTROL = '104px';
exports.DEFAULT_TEXTS = {
    hours: 'Hours:',
    minutes: 'Minutes:',
    am: 'AM',
    pm: 'PM',
    apply: 'Apply',
    cancel: 'Cancel',
    errorHoursRequiredText: 'Please select a hours',
    errorMinutesRequiredText: 'Please select a minutes'
};
exports.dataSelectorId = {
    timePickerControl: 'timepicker-control',
    timeSelector: 'time-selector',
    timeSelectorWrapper: 'time-selector-wrapper',
    applyControl: 'apply-control',
    cancelControl: 'cancel-control'
};
//# sourceMappingURL=helpers.js.map